﻿(function ($) {

$(function () {
		//Custom select box
		$('select.ui-cmb').each(function () {
			var wrapper = $(document.createElement('div')).addClass('ui-cmb-wrap');
			var select = $(document.createElement('div')).addClass('select').text($(this).find('option:selected').text());

			//Change text in select div when choosing option
			$(this).bind('change', function () {
				select.text($(this).find('option:selected').text());
			}).wrap(wrapper).after(select).css({ opacity: '0', position: 'absolute', top: '0', left: '0', width: '100%' });

			$(this).bind('focus', function () {
				$(this).parent().addClass("focus");
			});

			$(this).bind('blur', function () {
				$(this).parent().removeClass("focus");
			});

			//Get padding on wrapper
			var paddingR = parseInt($(this).parent().css("padding-right"));
			var paddingL = parseInt($(this).parent().css("padding-left"));

			//Set min-width to select div
			/*var minWidth = $(this).outerWidth();
			select.css({ minWidth: (minWidth - paddingL - paddingR) });*/


			//Set correct width to selectbox in IE7
			if ($.browser.msie && parseInt($.browser.version, 10) <= 7) {
				var wrapWidth = $(this).parent().outerWidth();
				$(this).css({ width: wrapWidth });
			}
		});
});

	var global = {
		showLoadingIconWithPos: function (selector, posTop, posRight, posBottom, posLeft) {
			var item = $(selector);
			if (!item.find(".loading-icon").length) { // If the icon is not already there
				item.data('oldposition', item.css('position'));

				if (posTop != null) {
				    item.css("position", "relative").append('<div class="loading-icon" style=\"top: ' + posTop + ';right: ' + posRight + ';bottom: ' + posBottom + ';left: ' + posLeft + '\"><img src="//assets.l.is/img/loading.gif" class="loading-img" alt="" /></div>');
				}
				else {
				    item.css("position", "relative").append('<div class="loading-icon"><img src="//assets.l.is/img/loading.gif" class="loading-img" alt="" /></div>');
				}
			}
		},
		showLoadingIcon: function (selector) {
			this.showLoadingIconWithPos(selector, null, null, null, null);
		},
		hideLoadingIcon: function (selector) {
			var item = $(selector);
			item.find(".loading-icon").hide();
			item.css("position", item.data('oldposition'));
			item.find(".loading-icon").remove();
		},
		ShortenName: function (name) {
			if (name != null && name.length > 26) {
				return name.substring(0, 26) + " ...";
			} else {
				return name;
			}
		},
		ShortenNameByLength: function (name, length) {
			if (name != null && name.length > length) {
				return name.substring(0, length) + " ...";
			} else {
				return name;
			}
		},		
		showOverlay: function () {
			if ($(".overlay").length == 0)
				$("body").append('<div class="overlay"></div>');
			$(".overlay").show();
		},
		fadeInOverlay: function (speed) {
			if ($(".overlay").length == 0)
				$("body").append('<div class="overlay"></div>');
			$(".overlay").fadeIn(speed);
		},
		hideOverlay: function () {
			$(".overlay").hide();
		},
		tabIndexEl: 'input,select,a,textarea',
		setTabIndex: function (objId, tabIndex, selectors) {
			if (selectors == null)
				selectors = this.tabIndexEl;

			$(objId).find(selectors).each(function () {
				if (this.type != "hidden") {
					var $input = $(this);
					$input.attr("tabindex", tabIndex);
					$input.click(function () {
						$(this).css("outline", "0");
					});
					tabIndex++;
				}
			});
		},
		displayMsg: function (type, details, title) {
			var box = $("div[id$=" + type + "Box_PanelBox]");
			box.slideUp(function () {
				if (!details) {
					return;
				}

				box.find("h3").html(title);
				if ($.isArray(details)) {
					var list = box.find('ul');
					$.each(details, function (msg) {
						list.push('<li>' + msg + '</li>');
					});
				} else {
					box.find("p").html(details);
				}
				box.removeClass('hide').slideDown();
			});
		},
		hideMsg: function (type) {
			$("div[id$=" + type + "Box_PanelBox]").slideUp();
		},
		displayError: function (details, title) {
			global.displayMsg('Error', details, title);
		},
		hideError: function () {
			global.hideMsg('Error');
		},
		displayNote: function (details, title) {
			global.displayMsg('Note', details, title);
		},
		hideNote: function () {
			global.hideMsg('Note');
		},
		displayConfirmation: function (details, title) {
			global.displayMsg('Confirmation', details, title);
		},
		hideConfirmation: function () {
			global.hideMsg('Confirmation');
		},
		displayValidation: function (details, title) {
			global.displayMsg('Validation', details, title);
		},
		hideValidation: function () {
			global.hideMsg('Validation');
		},
		validateKennitalaByValue: function (val) {
			if (val.length == 0) return true;
			var bReg = false;
			var regex = new RegExp("^([0-9]{6})(-?)([0-9]{3})[890]$");
			bReg = regex.test(val);

			if (!bReg)
				return false;

			if (val.length > 9 || val.length < 12) {
				if (val.length == 11) //ef það er bandstrik
					val = val.replace("-", "");

				var nSumma = 0;
				nSumma = parseInt(val.substr(0, 1)) * 3 + parseInt(val.substr(1, 1)) * 2 +
					parseInt(val.substr(2, 1)) * 7 + parseInt(val.substr(3, 1)) * 6 +
					parseInt(val.substr(4, 1)) * 5 + parseInt(val.substr(5, 1)) * 4 +
					parseInt(val.substr(6, 1)) * 3 + parseInt(val.substr(7, 1)) * 2;

				var nVartala = 0;
				nVartala = 11 - (nSumma % 11);

				if (nVartala == 11)
					nVartala = 0;

				if (nVartala != parseInt(val.substr(8, 1)))
					return false;
				else
					return true;

			}
			else
				return false;
		}
	};
	window.global = global;

})(jQuery);